// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.carbonara-webhooks-redirect--container {\n  margin: 24px auto;\n  width: 65%;\n  background: white;\n  padding: 24px;\n  border-radius: 3px;\n}\n\n.carbonara-webhooks-redirect--loading {\n  display: flex;\n  align-items: baseline;\n  color: var(--color-grey-4);\n}", ""]);
// Exports
module.exports = exports;
